"use strict";
exports.__esModule = true;
exports.Association = exports.DeliveryMethod = exports.RogueReasons = exports.PreparationStatus = exports.PaymentMethods = exports.PickupDropoffOption = exports.StatusChangedType = exports.TaskAutomaticallyCancelled = exports.TaskTypeId = exports.ScanningRole = exports.InventoryChangeType = exports.TaskStatus = exports.AddressType = exports.TaskHistoryOrigin = exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["FormattedTaskNote"] = "FormattedTaskNote";
    NoteType["Form"] = "Form";
    NoteType["TaskNote"] = "TaskNote";
    NoteType["TaskPhoto"] = "TaskPhoto";
    NoteType["TipSignature"] = "TipSignature";
    NoteType["HtmlTaskNote"] = "HtmlTaskNote";
    NoteType["Signature"] = "Signature";
    NoteType["Document"] = "Document";
})(NoteType = exports.NoteType || (exports.NoteType = {}));
var TaskHistoryOrigin;
(function (TaskHistoryOrigin) {
    TaskHistoryOrigin[TaskHistoryOrigin["UNKNOWN"] = 0] = "UNKNOWN";
    TaskHistoryOrigin[TaskHistoryOrigin["ROUTE_OPTIMIZATION"] = 1] = "ROUTE_OPTIMIZATION";
    TaskHistoryOrigin[TaskHistoryOrigin["AUTO_DISPATCH"] = 2] = "AUTO_DISPATCH";
    TaskHistoryOrigin[TaskHistoryOrigin["BROADCAST"] = 3] = "BROADCAST";
    TaskHistoryOrigin[TaskHistoryOrigin["MANUAL"] = 4] = "MANUAL";
    TaskHistoryOrigin[TaskHistoryOrigin["REJECT"] = 5] = "REJECT";
    TaskHistoryOrigin[TaskHistoryOrigin["AUTO_REJECT"] = 6] = "AUTO_REJECT";
    TaskHistoryOrigin[TaskHistoryOrigin["USER_ACCEPTED"] = 7] = "USER_ACCEPTED";
    TaskHistoryOrigin[TaskHistoryOrigin["FLEET"] = 8] = "FLEET";
})(TaskHistoryOrigin = exports.TaskHistoryOrigin || (exports.TaskHistoryOrigin = {}));
var AddressType;
(function (AddressType) {
    AddressType[AddressType["Commercial"] = 1] = "Commercial";
    AddressType[AddressType["Residential"] = 2] = "Residential";
    AddressType[AddressType["Educational"] = 3] = "Educational";
    AddressType[AddressType["Government"] = 4] = "Government";
    AddressType[AddressType["Medical"] = 5] = "Medical";
    AddressType[AddressType["Industrial"] = 6] = "Industrial";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Created"] = 0] = "Created";
    TaskStatus[TaskStatus["Assigned"] = 1] = "Assigned";
    TaskStatus[TaskStatus["OnTheWay"] = 2] = "OnTheWay";
    TaskStatus[TaskStatus["CheckedIn"] = 3] = "CheckedIn";
    TaskStatus[TaskStatus["Done"] = 4] = "Done";
    TaskStatus[TaskStatus["Late"] = 5] = "Late";
    TaskStatus[TaskStatus["Accepted"] = 6] = "Accepted";
    TaskStatus[TaskStatus["Cancelled"] = 7] = "Cancelled";
    TaskStatus[TaskStatus["Rejected"] = 8] = "Rejected";
    TaskStatus[TaskStatus["Unacknowledged"] = 9] = "Unacknowledged";
    TaskStatus[TaskStatus["Pending"] = 10] = "Pending";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var InventoryChangeType;
(function (InventoryChangeType) {
    InventoryChangeType[InventoryChangeType["Quantity"] = 0] = "Quantity";
    InventoryChangeType[InventoryChangeType["OriginalQuantity"] = 1] = "OriginalQuantity";
    InventoryChangeType[InventoryChangeType["RejectedQuantity"] = 2] = "RejectedQuantity";
})(InventoryChangeType = exports.InventoryChangeType || (exports.InventoryChangeType = {}));
var ScanningRole;
(function (ScanningRole) {
    ScanningRole[ScanningRole["DRIVER"] = 0] = "DRIVER";
    ScanningRole[ScanningRole["DISPATCHER_STAGING"] = 1] = "DISPATCHER_STAGING";
    ScanningRole[ScanningRole["DISPATCHER_COC"] = 2] = "DISPATCHER_COC";
})(ScanningRole = exports.ScanningRole || (exports.ScanningRole = {}));
var TaskTypeId;
(function (TaskTypeId) {
    TaskTypeId[TaskTypeId["PICKUP"] = 2] = "PICKUP";
    TaskTypeId[TaskTypeId["RETURN_TASK"] = 3] = "RETURN_TASK";
    TaskTypeId[TaskTypeId["DELIVERY"] = 4] = "DELIVERY";
    TaskTypeId[TaskTypeId["PICKUP_AND_DELIVERY"] = 5] = "PICKUP_AND_DELIVERY";
    TaskTypeId[TaskTypeId["CLICK_AND_COLLECT"] = 6] = "CLICK_AND_COLLECT";
    TaskTypeId[TaskTypeId["SERVICE"] = 7] = "SERVICE";
    TaskTypeId[TaskTypeId["ROAMING"] = 8] = "ROAMING";
})(TaskTypeId = exports.TaskTypeId || (exports.TaskTypeId = {}));
var TaskAutomaticallyCancelled;
(function (TaskAutomaticallyCancelled) {
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["MANUAL"] = 0] = "MANUAL";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["AUTOMATIC"] = 1] = "AUTOMATIC";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_APPLICATION"] = 2] = "FROM_APPLICATION";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_LINKED_TASK"] = 3] = "FROM_LINKED_TASK";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_API"] = 4] = "FROM_API";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_FLEET"] = 5] = "FROM_FLEET";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["AUTOMATIC_FROM_FLEET"] = 6] = "AUTOMATIC_FROM_FLEET";
})(TaskAutomaticallyCancelled = exports.TaskAutomaticallyCancelled || (exports.TaskAutomaticallyCancelled = {}));
var StatusChangedType;
(function (StatusChangedType) {
    StatusChangedType[StatusChangedType["Manual"] = 0] = "Manual";
    StatusChangedType[StatusChangedType["Automatic"] = 1] = "Automatic";
    StatusChangedType[StatusChangedType["Suggested"] = 2] = "Suggested";
    StatusChangedType[StatusChangedType["AutoCorrectedByClient"] = 4] = "AutoCorrectedByClient";
    StatusChangedType[StatusChangedType["AutoCorrectedByServer"] = 5] = "AutoCorrectedByServer";
    StatusChangedType[StatusChangedType["AutomatedByActivityTrigger"] = 6] = "AutomatedByActivityTrigger";
    StatusChangedType[StatusChangedType["FromDashboard"] = 7] = "FromDashboard";
    StatusChangedType[StatusChangedType["FromApplication"] = 8] = "FromApplication";
    StatusChangedType[StatusChangedType["FromRunEnv"] = 9] = "FromRunEnv";
    StatusChangedType[StatusChangedType["AutomaticByServer"] = 10] = "AutomaticByServer";
    StatusChangedType[StatusChangedType["FromApi"] = 11] = "FromApi";
    StatusChangedType[StatusChangedType["AutomaticFromFleet"] = 12] = "AutomaticFromFleet";
})(StatusChangedType = exports.StatusChangedType || (exports.StatusChangedType = {}));
var PickupDropoffOption;
(function (PickupDropoffOption) {
    PickupDropoffOption[PickupDropoffOption["PICKUP"] = 0] = "PICKUP";
    PickupDropoffOption[PickupDropoffOption["DROPOFF"] = 1] = "DROPOFF";
    PickupDropoffOption[PickupDropoffOption["BOTH"] = 2] = "BOTH";
})(PickupDropoffOption = exports.PickupDropoffOption || (exports.PickupDropoffOption = {}));
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods[PaymentMethods["UNKNOWN"] = 0] = "UNKNOWN";
    PaymentMethods[PaymentMethods["CASH"] = 1] = "CASH";
    PaymentMethods[PaymentMethods["CREDIT"] = 2] = "CREDIT";
    PaymentMethods[PaymentMethods["CHEQUE"] = 3] = "CHEQUE";
    PaymentMethods[PaymentMethods["CREDIT_CARD_TERMINAL"] = 4] = "CREDIT_CARD_TERMINAL";
})(PaymentMethods = exports.PaymentMethods || (exports.PaymentMethods = {}));
var PreparationStatus;
(function (PreparationStatus) {
    PreparationStatus[PreparationStatus["ACKNOWLEDGED"] = 0] = "ACKNOWLEDGED";
    PreparationStatus[PreparationStatus["START_PREPARATION"] = 1] = "START_PREPARATION";
    PreparationStatus[PreparationStatus["PREPARATION_STARTED"] = 2] = "PREPARATION_STARTED";
    PreparationStatus[PreparationStatus["READY_FOR_PICKUP"] = 3] = "READY_FOR_PICKUP";
    PreparationStatus[PreparationStatus["PICKED_UP"] = 4] = "PICKED_UP";
    PreparationStatus[PreparationStatus["SEND_TO_PREPARATION_FAILED"] = 5] = "SEND_TO_PREPARATION_FAILED";
    PreparationStatus[PreparationStatus["UNACKNOWLEDGED"] = 6] = "UNACKNOWLEDGED";
})(PreparationStatus = exports.PreparationStatus || (exports.PreparationStatus = {}));
var RogueReasons;
(function (RogueReasons) {
    RogueReasons[RogueReasons["TIME_WINDOW"] = 0] = "TIME_WINDOW";
    RogueReasons[RogueReasons["CAPACITY"] = 1] = "CAPACITY";
})(RogueReasons = exports.RogueReasons || (exports.RogueReasons = {}));
var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Contactless"] = "contactless";
    DeliveryMethod["StreetLevel"] = "street_level";
    DeliveryMethod["AtRoom"] = "at_room";
    DeliveryMethod["ThirdPartyPoint"] = "third_party_point";
})(DeliveryMethod = exports.DeliveryMethod || (exports.DeliveryMethod = {}));
var Association;
(function (Association) {
    Association["WayPoint"] = "way_point";
    Association["TaskInventory"] = "task_inventory";
    Association["Form"] = "form";
    Association["TaskNote"] = "task_note";
    Association["TaskPhoto"] = "task_photo";
    Association["Signature"] = "signature";
})(Association = exports.Association || (exports.Association = {}));
//# sourceMappingURL=task.js.map